module.exports = __webpack_public_path__ + "static/media/42_A.a44f6541.png";